




// import { Link } from "react-router-dom";
// import PageBanner from "../../PageBanner";
// import SocialMediaSidebar from "../../SocialMediaSidebar";
// import SectionHeader from "../../SectionHeader";
// import ScrollToTopButton from "../../ScrollToTopButton";
// import ANPR from "../../../assets/images/anpr.png"
// import EnvironmentalDashboard from "../../../assets/images/EnvironmentalMonitoring.png"

// const OfferingANPR = () => {
//   return (
//     <>
//       <div>
//         <SocialMediaSidebar />
//       </div>
//       <PageBanner
//         title="Environmental Monitoring"
//         breadcrumb={[
//           { label: "Home", href: "/" },
//           { label: "Offerings" },
//         ]}
//       />
//       <div className="max-w-6xl mx-auto p-4">
//         <SectionHeader
//           title="Environmental Monitoring @ AJEEVI"
//           shareUrl="https://swmecom.ajeevi.in/grievance-redressal"
//         />
//       </div>
//       <div>
//         <ScrollToTopButton />
//       </div>

//       {/* Page content */}
//       <div className="w-full px-4 sm:px-6 md:px-10 lg:px-28 py-10 bg-white text-gray-800 text-justify">
//   <div className="container mx-auto px-4 sm:px-6 lg:px-8">
//     {/* Summary Section */}
//     <div className="flex flex-col md:flex-row items-center md:items-start gap-8 mb-10">
//       {/* Text Section */}
//       <div className="md:w-1/2">
//         <h4 className="text-[#00D084] text-2xl font-semibold mb-3">
//           Summary
//         </h4>
//         <p className="text-black mb-4 text-lg">
//           Smart pole environmental monitoring systems transform urban management by providing real-time data on air quality, noise levels, temperature, and humidity. This integrated technology enables cities to track environmental conditions, identify pollution hotspots, and implement data-driven policies for healthier communities.
//         </p>
//         <p className="text-black text-lg">
//           Municipalities implementing environmental monitoring achieve significant improvements in public health awareness, pollution reduction strategies, and climate-responsive urban planning while meeting sustainability goals.
//         </p>
//       </div>

//       {/* Image Section */}
//       <div className="md:w-1/2">
//         <img
//           src={EnvironmentalDashboard}
//           alt="Environmental Monitoring Dashboard"
//           className="w-full h-auto rounded-lg shadow-md"
//         />
//       </div>
//     </div>

//     {/* Introduction Section */}
//     <div className="mb-10">
//       <h4 className="text-[#00D084] text-2xl font-semibold mb-3">
//         Introduction
//       </h4>
//       <p className="text-black mb-4 text-lg">
//         In today's urban environments, monitoring environmental conditions is essential for public health and sustainable development. Smart pole environmental sensors provide continuous, hyperlocal data on key air quality and weather parameters across city landscapes.
//       </p>
//       <p className="text-black text-lg">
//         By deploying networked environmental sensors on smart poles, cities gain actionable insights to address pollution, mitigate urban heat islands, and create healthier public spaces through informed policy decisions.
//       </p>
//     </div>

//     {/* Key Features Section */}
//     <div className="mb-10">
//       <h5 className="text-xl font-semibold mb-4 text-black">
//         Key Features of Environmental Monitoring Systems:
//       </h5>
//       <ul className="list-disc pl-6 space-y-2 text-lg text-black">
//         <li>
//           <strong>Comprehensive Air Quality Analysis:</strong> Measures PM2.5, PM10, CO2, NO2, O3, and other pollutants
//         </li>
//         <li>
//           <strong>Noise Level Monitoring:</strong> Tracks decibel levels to identify noise pollution sources
//         </li>
//         <li>
//           <strong>Weather Conditions:</strong> Records temperature, humidity, atmospheric pressure, and rainfall
//         </li>
//         <li>
//           <strong>Real-Time Data Transmission:</strong> Continuous updates to central management platforms
//         </li>
//         <li>
//           <strong>Pollution Heatmaps:</strong> Visual representations of environmental data across urban areas
//         </li>
//         <li>
//           <strong>Public Health Alerts:</strong> Notifications when parameters exceed safety thresholds
//         </li>
//       </ul>
//     </div>

//     {/* Benefits Section */}
//     <div className="mb-10">
//       <h5 className="text-xl font-semibold mb-3 text-black">
//         Operational Benefits
//       </h5>
//       <p className="text-black text-lg mb-4">
//         Implementing environmental monitoring delivers measurable improvements:
//       </p>
//       <ul className="list-disc pl-6 space-y-2 text-lg text-black mb-4">
//         <li>Data-driven pollution reduction strategies</li>
//         <li>Early warning systems for public health risks</li>
//         <li>Improved urban planning based on microclimate data</li>
//         <li>30-50% faster response to environmental incidents</li>
//         <li>Compliance with air quality regulations and reporting</li>
//         <li>Increased public awareness of local environmental conditions</li>
//       </ul>
//     </div>

//     {/* Implementation Section */}
//     <div className="mb-10">
//       <h5 className="text-xl font-semibold mb-3 text-black">
//         Implementation Considerations
//       </h5>
//       <p className="text-black text-lg mb-4">
//         Successful environmental monitoring deployment requires:
//       </p>
//       <ul className="list-disc pl-6 space-y-2 text-lg text-black mb-4">
//         <li>Strategic sensor placement for representative data collection</li>
//         <li>Calibration protocols to maintain measurement accuracy</li>
//         <li>Integration with urban management platforms</li>
//         <li>Data visualization tools for actionable insights</li>
//         <li>Public communication channels for environmental alerts</li>
//         <li>Regular maintenance and sensor cleaning schedules</li>
//       </ul>
//     </div>

//     {/* Ajeevi's Contribution Section */}
//     <div>
//       <h5 className="text-xl font-semibold mb-3 text-black">
//         Ajeevi's Environmental Monitoring Solutions
//       </h5>
//       <p className="text-black mb-4 text-lg">
//         Ajeevi provides comprehensive environmental monitoring systems for smart cities:
//       </p>
//       <ul className="list-disc pl-6 space-y-2 text-lg text-black mb-4">
//         <li>
//           <strong>Multi-Parameter Sensors:</strong> Integrated air quality, noise, and weather monitoring
//         </li>
//         <li>
//           <strong>AI-Powered Analytics:</strong> Identifies pollution patterns and predicts trends
//         </li>
//         <li>
//           <strong>Real-Time Dashboard:</strong> Centralized view of environmental conditions citywide
//         </li>
//         <li>
//           <strong>Automated Reporting:</strong> Generates compliance documents and public disclosures
//         </li>
//         <li>
//           <strong>Smart City Integration:</strong> Connects with traffic and urban planning systems
//         </li>
//       </ul>
//       <p className="text-black text-lg">
//         Discover how Ajeevi's environmental monitoring can create healthier urban spaces. Visit{" "}
//         <a
//           href="http://www.ajeevi.com"
//           target="_blank"
//           rel="noopener noreferrer"
//           className="text-[#00D084] hover:underline"
//         >
//           www.ajeevi.com
//         </a>{" "}
//         for more information.
//       </p>
//     </div>
//   </div>
// </div>
//     </>
//   );
// };

// export default OfferingANPR;


import { Link } from "react-router-dom";
import PageBanner from "../../PageBanner";
import SocialMediaSidebar from "../../SocialMediaSidebar";
import SectionHeader from "../../SectionHeader";
import ScrollToTopButton from "../../ScrollToTopButton";
import EnvironmentalDashboard from "../../../assets/images/EnvironmentalMonitoring.png";

const OfferingEnvironmentSensing = () => {
  return (
    <>
      <div>
        <SocialMediaSidebar />
      </div>
      <PageBanner
        title="Environment & Disaster Sensing"
        breadcrumb={[
          { label: "Home", href: "/" },
          { label: "Offerings" },
        ]}
      />
      <div className="max-w-6xl mx-auto p-4">
        <SectionHeader
          title="Environment & Disaster Sensing @ AJEEVI"
          shareUrl="https://swmecom.ajeevi.in/grievance-redressal"
        />
      </div>
      <div>
        <ScrollToTopButton />
      </div>

      {/* Page content */}
      <div className="w-full px-4 sm:px-6 md:px-10 lg:px-28 py-10 bg-white text-gray-800 text-justify">
        <div className="container mx-auto px-4 sm:px-6 lg:px-8">
          {/* Summary Section */}
          <div className="flex flex-col md:flex-row items-center md:items-start gap-8 mb-10">
            <div className="md:w-1/2">
              <h4 className="text-[#00D084] text-2xl font-semibold mb-3">
                Summary
              </h4>
              <p className="text-black mb-4 text-lg">
                Ajeevi’s Environment & Disaster Sensing solution offers real-time tracking of environmental parameters such as air quality, temperature, humidity, and water levels. By integrating smart sensors into city infrastructure, municipalities gain early warnings of floods and pollution events.
              </p>
              <p className="text-black text-lg">
                This proactive system supports safer, healthier, and more resilient urban living by enabling quick response and informed policy decisions.
              </p>
            </div>
            <div className="md:w-1/2">
              <img
                src={EnvironmentalDashboard}
                alt="Environment & Disaster Sensing Dashboard"
                className="w-full h-auto rounded-lg shadow-md"
              />
            </div>
          </div>

          {/* Introduction Section */}
          <div className="mb-10">
            <h4 className="text-[#00D084] text-2xl font-semibold mb-3">
              Introduction
            </h4>
            <p className="text-black mb-4 text-lg">
              Environmental risks such as air pollution, climate change, and flooding are rising globally. Ajeevi’s intelligent sensing infrastructure captures continuous, real-time data on air quality, weather, and hydrological factors to inform rapid responses and long-term planning.
            </p>
            <p className="text-black text-lg">
              Through smart poles and IoT-enabled platforms, the system empowers cities to predict, detect, and mitigate environmental threats before they escalate into disasters.
            </p>
          </div>

          {/* Key Features Section */}
          <div className="mb-10">
            <h5 className="text-xl font-semibold mb-4 text-black">
              Key Features of Environment & Disaster Sensing:
            </h5>
            <ul className="list-disc pl-6 space-y-2 text-lg text-black">
              <li>
                <strong>Air Quality Monitoring:</strong> Tracks PM2.5, PM10, CO, NO2, and other pollutants
              </li>
              <li>
                <strong>Weather Tracking:</strong> Measures temperature, humidity, and barometric pressure
              </li>
              <li>
                <strong>Flood Detection Sensors:</strong> Alerts when water levels rise in sensitive zones
              </li>
              <li>
                <strong>Real-Time Alerts:</strong> Instant notifications for threshold breaches
              </li>
              <li>
                <strong>Smart Mapping:</strong> GIS-based visualization of environmental risks
              </li>
              <li>
                <strong>Data Dashboard:</strong> Centralized control panel for city administrators
              </li>
            </ul>
          </div>

          {/* Benefits Section */}
          <div className="mb-10">
            <h5 className="text-xl font-semibold mb-3 text-black">
              Operational Benefits
            </h5>
            <p className="text-black text-lg mb-4">
              Deploying Ajeevi’s environment and disaster sensing enables:
            </p>
            <ul className="list-disc pl-6 space-y-2 text-lg text-black mb-4">
              <li>Advanced warning of flood or pollution-related hazards</li>
              <li>Improved disaster preparedness and urban resilience</li>
              <li>Healthier communities through proactive pollution control</li>
              <li>Better resource allocation during emergencies</li>
              <li>Enhanced policy and infrastructure planning</li>
            </ul>
          </div>

          {/* Implementation Section */}
          <div className="mb-10">
            <h5 className="text-xl font-semibold mb-3 text-black">
              Implementation Strategy
            </h5>
            <p className="text-black text-lg mb-4">
              For successful deployment, Ajeevi recommends:
            </p>
            <ul className="list-disc pl-6 space-y-2 text-lg text-black mb-4">
              <li>Installing sensors in flood-prone and high-pollution zones</li>
              <li>Calibrating devices with national and global standards</li>
              <li>Integrating with city-level emergency response systems</li>
              <li>Ensuring network redundancy for uninterrupted monitoring</li>
              <li>Training local teams for real-time interpretation and action</li>
            </ul>
          </div>

          {/* Ajeevi's Solution Section */}
          <div>
            <h5 className="text-xl font-semibold mb-3 text-black">
              Ajeevi's Environment & Disaster Sensing Platform
            </h5>
            <p className="text-black mb-4 text-lg">
              Ajeevi’s modular and scalable system is tailored for city-wide deployment:
            </p>
            <ul className="list-disc pl-6 space-y-2 text-lg text-black mb-4">
              <li>
                <strong>Multi-Sensor Nodes:</strong> Support for air, weather, and water level sensing
              </li>
              <li>
                <strong>Integrated Dashboard:</strong> Unified view with alert controls and trend analytics
              </li>
              <li>
                <strong>Predictive Insights:</strong> AI tools for flood forecasting and pollution trend analysis
              </li>
              <li>
                <strong>Mobile App Integration:</strong> Real-time alerts for citizens and authorities
              </li>
              <li>
                <strong>Interoperable Framework:</strong> Compatible with existing disaster management systems
              </li>
            </ul>
            <p className="text-black text-lg">
              Learn more about how Ajeevi helps cities build smarter, safer environments. Visit{" "}
              <a
                href="http://www.ajeevi.com"
                target="_blank"
                rel="noopener noreferrer"
                className="text-[#00D084] hover:underline"
              >
                www.ajeevi.com
              </a>{" "}
              for further details.
            </p>
          </div>
        </div>
      </div>
    </>
  );
};

export default OfferingEnvironmentSensing;
